<template>
    <div class="app-secondary-container">
        <aside class="app-aside scrollfix">
            <div class="app-aside__content scrollfix">
                <project-extension-nav/>
            </div>
        </aside>
        <main class="app-main">
            <router-view/>
        </main>
    </div>
</template>

</template>
<script>
import ProjectExtensionNav
    from '@/modules/ProjectModule/modules/ExtensionModule/components/Nav/ProjectExtensionNav';

export default {
    components: { ProjectExtensionNav }
}
</script>
